import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ComboBox, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const StoreRestockDefaultLocation = ({ store, locations, onChangeLocation }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.StoreContainer key={store?.store_id}>
      <Styles.StoreLabelContainer>
        <Styles.StoreImage src={store?.store_logo_url} alt={store?.store_name} />
        <Text type="titleS">{store?.store_name}</Text>
      </Styles.StoreLabelContainer>
      <ComboBox
        menuItems={locations?.map(location => ({ label: location.name, value: location.id })) || []}
        value={store?.default_restock_location_id}
        label={t('Sucursal')}
        handleChange={e => onChangeLocation(store.store_id, e.target.value)}
        backgroundColor={theme.colors.background.primary}
      />
    </Styles.StoreContainer>
  )
}

export default StoreRestockDefaultLocation
